import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { checkAppointmentStatusApi } from "@/utils/apis/doctor/appointment";

import { IAppointmentStatusResult } from "@/models/ApiRequestResponse/doctor";
import { IAppointmentPaymentStatus } from "@/models/patient";

import { RootState } from "@/store/store";

export const fetchBookedAppointmentDetail = createAsyncThunk(
  "patient/paymentDetail",
  async ({
    bookingId,
    isDetailed,
  }: {
    bookingId: string;
    isDetailed: boolean;
  }) => {
    const response = await checkAppointmentStatusApi(bookingId, isDetailed);
    return response;
  }
);

const initialState = {
  isLoading: true as boolean,
  bookedAppointmentDetail: {} as IAppointmentStatusResult,
  paymentStatus: "" as IAppointmentPaymentStatus,
  isPaymentRedirected: false as boolean,
  bookingId: "" as string,
};

const fetchPatientMembersSlice = createSlice({
  name: "fetchPaymentDetail",
  initialState,
  reducers: {
    setPaymentStatus: (state, action) => {
      state.paymentStatus = action.payload;
    },
    setPaymentRedirected: (state, action) => {
      state.isPaymentRedirected = action.payload;
    },
    setBookingId: (state, action) => {
      state.bookingId = action.payload;
    },
    resetPayment: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookedAppointmentDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBookedAppointmentDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        if ("result" in action.payload) {
          state.bookedAppointmentDetail = action.payload.result;
        }
      })
      .addCase(fetchBookedAppointmentDetail.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
export const {
  setPaymentStatus,
  setPaymentRedirected,
  setBookingId,
  resetPayment,
} = fetchPatientMembersSlice.actions;

const selectPayment = (state: RootState) => state.payment;

export const payment = createSelector([selectPayment], (selectPayment) => {
  return {
    bookedAppointmentDetail: selectPayment.bookedAppointmentDetail,
    paymentStatus: selectPayment.paymentStatus,
    isPaymentRedirected: selectPayment.isPaymentRedirected,
    bookingId: selectPayment.bookingId,
    isLoading: selectPayment.isLoading,
  };
});
export default fetchPatientMembersSlice.reducer;
